import Service from './Service'

/**
 * Organization profile API service.
 */
export default class Organization extends Service {
	/**
	 * Get the organization profile by id.
	 *
	 * @return {Promise}
	 * @param {number} id - The organization id.
	 */
	get(id) {
		return this.request.get(`v1/organizations/${id}`)
	}

	/**
	 * Update the organization profile by id.
	 *
	 * @return {Promise}
	 * @param {number} id - The organization id.
	 * @param {Object} payload - The organization data to update.
	 */
	patch(id, payload) {
		return this.request.patch(`v1/organizations/${id}`, payload)
	}
}
